import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import MajidLogo from 'assets/images/majid-logo-white.svg';
import { Link, Outlet, useSearchParams } from 'react-router-dom';
import './esaad-layout.css';
import { ROUTES, ESAAD_NAME } from 'constants';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from 'constants';

const EsaadLayout = ({ children }) => {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const lang = searchParams.get('lang');
    if (lang) {
      i18n.changeLanguage(lang);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
  document.title = ESAAD_NAME;
  document.body.style.backgroundColor = '#8A1538';
  return (
    <div
      className="container p-3"
      style={{ direction: i18n.language === LANGUAGES.ARABIC.langCode ? 'rtl' : 'ltr' }}
    >
      <div className="navbar navbar-expand-lg navbar-light">
        <Link to={ROUTES.ESAAD_CARD.ROOT}>
          <img
            src={MajidLogo}
            className="img-responsive"
            style={{ width: 165 }}
            alt="brand-logo"
          />
        </Link>
      </div>
      <Outlet />
    </div>
  );
};

EsaadLayout.propTypes = {
  children: PropTypes.node
};

export default EsaadLayout;
